import {createSelector} from 'reselect';
import getUi from './getUi';

export default createSelector(
  [getUi],
  ui => ui.checkoutProgressStep,
);
